<template>
    <div class="about-section about-content">
      <h1 class="title-about-our">"Ayuda a tu hijo con herramientas que le permitan adaptarse y prosperar en un mundo que ya cambio"</h1>
      <a
        class="cta-button-big"
        href="https://api.whatsapp.com/send?phone=5215561461518&text=%C2%A1Quiero%20empezar%20mi%20diagn%C3%B3stico%20gratis!%F0%9F%98%80"
        target="_blank"
        rel="noopener"
      >
        INICIAR CONVERSACIÓN
      </a>
    </div>
</template>

<script>
export default {
  name: 'OurExpertsSection'
}
</script>

<style scoped>
.about-section {
    width: 100%;
    height: 700px;
    background: url('../../assets/img/image\ 12.jpg') no-repeat center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .about-content {
    display: flex;
    max-height: 1400px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }

  @media (max-width: 768px) {
  .about-section {
    height: auto;
    min-height: 140px;
    padding: 10px 0;
    background-size: cover;
  }
  .about-content {
    max-height: none;
    gap: 14px;
    padding: 0 2vw;
  }
  .title-about-our {
    font-size: 16px;
    padding: 0 16px;
    line-height: 1.15;
    word-break: break-word;
    text-align: center;
  }
  .cta-button-big {
    font-size: 1.1rem;
    padding: 12px 32px;
    border-radius: 8px;
    background: #C58911;
    color: #fff;
    font-weight: 600;
    text-decoration: none;
    transition: background 0.2s;
    display: inline-block;
    margin-top: 8px;
    border: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    cursor: pointer;
    outline: none;
  }
  .cta-button-big:hover,
  .cta-button-big:focus {
    background: #a06d0a;
    color: #fff;
    text-decoration: none;
  }
}
</style>